import React, { useCallback, useEffect, useState } from 'react';
import { Slide } from "./Slide.jsx";
import useEmblaCarousel from 'embla-carousel-react';


const Thumb = (props) => {
  const { selected, item, onClick } = props

  return (
    <div
      className={'embla-thumbs__slide'.concat(
        selected ? ' embla-thumbs__slide--selected' : ''
      )}
    >
      <button
        onClick={onClick}
        type="button"
        className="btn"
      >
        {item}
        
      </button>
    </div>
  );
}

export function SlideshowWidget({children, configuration}) {
  if (!children?.length) return null;
  const options = {
    direction: 'ltr',
    loop: true
  }

  // TODO: hay que tener en cuenta media queries para pantallas pequeñas
  // https://www.embla-carousel.com/guides/slide-sizes/
  let slideStyle = {
    "--slide-size": `${100 / configuration.concurrentSlides}%`,
  };
  
  if(window.innerWidth < 768){
    slideStyle = {
      "--slide-size": "85%",
    };
  }

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  let emblaThumbsRef = null;
  let emblaThumbsApi = null;

  window.emblaApi = emblaApi;

  const onSelect = useCallback(() => {
    return;
    if (emblaApi) {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    }
    if (emblaThumbsApi) {
      emblaThumbsApi.scrollTo(emblaApi.selectedScrollSnap())
    }
  }, [emblaApi, emblaThumbsApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();

    emblaApi.on('select', onSelect).on('reinit', onSelect);
  }, [emblaApi, onSelect]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  let emblaControls = "";
  if (children.length > 1) {
      emblaControls= (
      <div className="embla__controls">
        <div className="embla__buttons">

          <button
            className="embla__button embla__button--prev"
            type="button"
            onClick={scrollPrev}
          >
            <svg className="embla__button__svg" viewBox="0 0 532 532"><path fill="#FFFFFF" d="M355.66 11.354c13.793-13.805 36.208-13.805 50.001 0 13.785 13.804 13.785 36.238 0 50.034L201.22 266l204.442 204.61c13.785 13.805 13.785 36.239 0 50.044-13.793 13.796-36.208 13.796-50.002 0a5994246.277 5994246.277 0 0 0-229.332-229.454 35.065 35.065 0 0 1-10.326-25.126c0-9.2 3.393-18.26 10.326-25.2C172.192 194.973 332.731 34.31 355.66 11.354Z" /></svg>
            <div className="visually-hidden">{configuration.translations.btnAnterior}</div>
          </button>

          <button
            className="embla__button embla__button--next"
            type="button"
            onClick={scrollNext}
          >
            <svg className="embla__button__svg" viewBox="0 0 532 532"><path fill="#FFFFFF" d="M176.34 520.646c-13.793 13.805-36.208 13.805-50.001 0-13.785-13.804-13.785-36.238 0-50.034L330.78 266 126.34 61.391c-13.785-13.805-13.785-36.239 0-50.044 13.793-13.796 36.208-13.796 50.002 0 22.928 22.947 206.395 206.507 229.332 229.454a35.065 35.065 0 0 1 10.326 25.126c0 9.2-3.393 18.26-10.326 25.2-45.865 45.901-206.404 206.564-229.332 229.52Z" /></svg>
            <div className="visually-hidden">{configuration.translations.btnSiguiente}</div>
          </button>
        </div>
      </div>
    )
  }

  let emblaThumbnails = "";
  if (configuration.showThumbnails) {
    [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
      containScroll: 'keepSnaps',
      dragFree: true
    });
    const onThumbClick = useCallback(
      (index) => {
        if (!emblaApi || !emblaThumbsApi) return
        emblaApi.scrollTo(index)
      },
      [emblaApi, emblaThumbsApi]
    )
    emblaThumbnails = (
      <div className="embla-thumbs">
        <div className="embla-thumbs__viewport" ref={emblaThumbsRef}>
          <div className="embla-thumbs__container">
            {children.map((child, index) => (
              <Thumb
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  onThumbClick(index);
                }}
                selected={index === selectedIndex}
                item={child}
              />
            ))}
          </div>
        </div>
      </div>
    )
  };

  return (
    <>
      <section className="embla" style={slideStyle}>
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {children.map((child, index) => (
              <div className="embla__slide slide pe-1" key={index}>{child}</div>
            ))}
          </div>
        </div>
        {emblaControls}
        {emblaThumbnails}
      </section>
    </>
  )
}
